import { Gift, Award, X } from "lucide-react";
import { useState, useEffect } from "react";

const FloatingBadges = () => {
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setDismissed(true), 10000);
    return () => clearTimeout(t);
  }, []);

  if (dismissed) return null;

  return (
    <div className="fixed bottom-6 left-6 z-[100] flex flex-col gap-3" data-testid="floating-badges">
      {/* OMS Partner Badge - Premium Gold/Black */}
      <a
        href="https://wa.me/919464645491?text=Hi%20BrandBorn!%20I%20heard%20you%20are%20Official%20OMS%20Partner%20of%20Myntra.%20I%20want%20to%20onboard%20my%20brand."
        target="_blank"
        rel="noopener noreferrer"
        className="group relative flex items-center gap-2.5 pl-4 pr-5 py-3 bg-gradient-to-r from-black via-gray-900 to-black text-white rounded-2xl font-black text-[11px] tracking-widest uppercase shadow-[0_4px_25px_rgba(0,0,0,0.4)] hover:shadow-[0_12px_40px_rgba(0,0,0,0.5)] transition-all duration-500 hover:-translate-y-1 border border-yellow-500/40 overflow-hidden"
        data-testid="oms-floating-badge"
      >
        {/* Shimmer effect */}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-yellow-400/10 to-transparent translate-x-[-200%] group-hover:translate-x-[200%] transition-transform duration-1000" />
        {/* Gold left accent */}
        <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-yellow-400 via-yellow-500 to-yellow-600" />
        <Award size={18} className="text-yellow-400 relative z-10 flex-shrink-0" />
        <div className="relative z-10 leading-tight">
          <span className="hidden sm:block text-yellow-400">Official OMS Partner</span>
          <span className="hidden sm:block text-[10px] text-gray-400 tracking-wider font-bold">OF MYNTRA</span>
          <span className="sm:hidden text-yellow-400">OMS Partner</span>
        </div>
      </a>

      {/* Refer & Get ₹5K Badge - Premium Red */}
      <button
        onClick={() => {
          const section = document.getElementById('referral-section');
          if (section) section.scrollIntoView({ behavior: 'smooth' });
        }}
        className="group relative flex items-center gap-2.5 pl-4 pr-5 py-3 bg-gradient-to-r from-red-700 via-red-600 to-red-700 text-white rounded-2xl font-black text-[11px] tracking-widest uppercase shadow-[0_4px_25px_rgba(220,38,38,0.4)] hover:shadow-[0_12px_40px_rgba(220,38,38,0.5)] transition-all duration-500 hover:-translate-y-1 border border-red-400/30 overflow-hidden"
        data-testid="referral-floating-badge"
      >
        {/* Shimmer effect */}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent translate-x-[-200%] group-hover:translate-x-[200%] transition-transform duration-1000" />
        {/* Red left accent */}
        <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-white via-red-200 to-white" />
        <Gift size={18} className="text-white relative z-10 flex-shrink-0 animate-pulse" />
        <div className="relative z-10 leading-tight">
          <span className="hidden sm:block">Refer & Get ₹5,000</span>
          <span className="hidden sm:block text-[10px] text-red-200 tracking-wider font-bold">PER BRAND REFERRAL</span>
          <span className="sm:hidden">Refer ₹5K</span>
        </div>
      </button>

      {/* Dismiss button */}
      <button
        onClick={() => setDismissed(true)}
        className="absolute -top-2 -right-2 w-5 h-5 bg-gray-800 text-gray-400 rounded-full flex items-center justify-center hover:bg-red-600 hover:text-white transition-all text-xs border border-gray-600"
        aria-label="Dismiss badges"
      >
        <X size={10} />
      </button>
    </div>
  );
};

export default FloatingBadges;
